import { createContext, useContext, useEffect, useState } from "react";
import { useAuth } from "./auth";

const ThemeContext = createContext(null);

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(() => {
    const stored = localStorage.getItem("jastip_theme");
    if (stored === "dark" || stored === "light") return stored;
    return window.matchMedia?.("(prefers-color-scheme: dark)").matches ? "dark" : "light";
  });
  const { user } = useAuth() || {};
  // Mode is buyer/jastiper/admin — drives the dynamic brand colour.
  const mode = user?.active_mode || user?.role || "buyer";

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    document.documentElement.classList.toggle("dark", theme === "dark");
    localStorage.setItem("jastip_theme", theme);
    const meta = document.querySelector('meta[name="theme-color"]');
    if (meta) meta.setAttribute("content", theme === "dark" ? "#0F172A" : modeBrand(mode));
  }, [theme, mode]);

  // Mode-aware brand colour: blue for buyer, green for jastiper, slate for admin.
  useEffect(() => {
    document.documentElement.setAttribute("data-mode", mode);
  }, [mode]);

  const toggle = () => setTheme((t) => (t === "dark" ? "light" : "dark"));

  return (
    <ThemeContext.Provider value={{ theme, setTheme, toggle, mode }}>{children}</ThemeContext.Provider>
  );
};

function modeBrand(mode) {
  if (mode === "jastiper") return "#059669";  // emerald
  if (mode === "admin") return "#1f2937";     // slate
  return "#002FA7";                            // klein blue (buyer / default)
}

export const useTheme = () => useContext(ThemeContext) || { theme: "light", toggle: () => {}, mode: "buyer" };
